"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safesportResultFactory = exports.safesportTrainingFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const mocks_1 = require("../../../mocks");
exports.safesportTrainingFactory = Factory.Sync.makeFactory({
    id: Factory.each(() => uuid_1.v4()),
    course: 'safesport',
    personaId: mocks_1.persona.id,
    email: mocks_1.persona.email,
    progress: 100,
    dateStarted: mocks_1.dates.date2000,
    dateCompleted: mocks_1.dates.date2100,
    completionCode: Factory.each(() => uuid_1.v4()),
    firstName: mocks_1.persona.first_name,
    lastName: mocks_1.persona.last_name,
    profileKey: 'safesport',
    dateExpiresOn: mocks_1.dates.date2100
});
exports.safesportResultFactory = Factory.Sync.makeFactory({
    status: 200,
    result: [
        exports.safesportTrainingFactory.build()
    ]
});
